export const checkNoResult = (leftContent) => leftContent
  .find(c => c.name === 'BOTGlobalSearchSummary')
  .searchResults.filter(r => Boolean(r.totalNumRecs)).length === 0

